var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.955 13.3353C15.8497 13.3353 18.4064 10.3652 18.6517 6.7198C18.7825 4.80378 18.1992 3.04148 17.0163 1.76779C15.9587 0.631354 14.5141 0 12.9496 0C11.385 0 9.92406 0.625864 8.87194 1.75681C7.69445 3.01952 7.12205 4.78182 7.24743 6.7198C7.49275 10.3707 10.0494 13.3353 12.9441 13.3353H12.955ZM12.955 1.49329C14.1053 1.49329 15.1628 1.95445 15.9369 2.78345C16.8364 3.75519 17.278 5.11122 17.1744 6.61549C16.9836 9.44835 15.0538 11.8365 12.955 11.8365C10.8562 11.8365 8.92646 9.44286 8.73566 6.61549C8.63208 5.10024 9.06819 3.73322 9.96222 2.77796C10.7309 1.94896 11.7939 1.49329 12.955 1.49329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.9699 24.7829C23.8414 18.398 17.7195 15.4883 12.5026 15.4883C7.28561 15.4883 1.16372 18.3925 0.0352836 24.7774C-0.0737439 25.3758 0.0734432 25.9688 0.427783 26.397C0.749414 26.7813 1.20733 26.9954 1.71976 26.9954H23.2799C23.7924 26.9954 24.2557 26.7813 24.5719 26.397C24.9317 25.9688 25.0734 25.3758 24.9644 24.7774L24.9699 24.7829ZM12.5026 16.9816C17.1144 16.9816 22.5277 19.507 23.5089 25.0409C23.5362 25.2002 23.5089 25.3539 23.438 25.4362C23.4053 25.4747 23.3672 25.5021 23.2799 25.5021H1.72521C1.63799 25.5021 1.59983 25.4747 1.56712 25.4362C1.49625 25.3484 1.46899 25.2002 1.49625 25.0409C2.47205 19.5015 7.88526 16.9816 12.4971 16.9816H12.5026Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2be9b8a5843e45359e5e2112d6f09c84.svg";
export { ForwardRef as ReactComponent };